module.exports = __webpack_public_path__ + "bf84a814f82bf88322eb3e08d7b7c8e6.pdf";